import Table from '../../table.js';

namespace('IO.Views.PaymentDeviceTypes', function (exports) {
  'use strict';

  var Index = Table.extend({
    dom: {
      DATATABLES: '.dataTables',
    },

    opts: {
      ajaxSource: 'payment_device_types.json',
      controller: '/payment_device_types',
      filter: true,
      oLanguage: {
        sZeroRecords: 'No payment device types created yet.',
      },
      title: 'Click to edit',
    },
  });

  exports.Index = Index;
});
